module.exports = __webpack_public_path__ + "static/media/top20.cd465ce9.png";